import { useSearchParams } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { GRNEditPage } from './GRNEditPage';

/** Full GRN edit requires /grn edit; store assignment (?mode=store) requires /stores edit. */
export function GrnEditRoute() {
  const [searchParams] = useSearchParams();
  const storeOnlyMode = searchParams.get('mode') === 'store';

  if (storeOnlyMode) {
    return (
      <ProtectedRoute requiredPermissions={{ route: '/stores', actions: ['edit'] }}>
        <GRNEditPage />
      </ProtectedRoute>
    );
  }

  return (
    <ProtectedRoute requiredPermissions={{ route: '/grn', actions: ['edit'] }}>
      <GRNEditPage />
    </ProtectedRoute>
  );
}
